// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__7Zn7A","title":"FAQ_title__Nvw+p","item":"FAQ_item__9Zzaq"};